import { render, staticRenderFns } from "./PopoverVideoCard.vue?vue&type=template&id=7a36f1ee&"
import script from "./PopoverVideoCard.vue?vue&type=script&lang=js&"
export * from "./PopoverVideoCard.vue?vue&type=script&lang=js&"
import style0 from "./PopoverVideoCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports